/* The cross-class league tables and recently-added feed (C-7). Tables use
   AllVenues.module.css; this adds the toolbar, tabs and link styles. */

.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 14px;
  padding: 8px 10px;
  border-bottom: 1px solid var(--line);
}

.tabs {
  display: inline-flex;
  flex-wrap: wrap;
  border: 1px solid var(--line-strong);
}

.tab {
  min-height: 28px;
  padding: 0 10px;
  border: 0;
  background: #0d0d0d;
  color: var(--ink-muted);
  cursor: pointer;
  font: inherit;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.tab + .tab {
  border-left: 1px solid var(--line-strong);
}

.tab:hover {
  color: var(--ink);
}

.tab[data-active="true"] {
  background: var(--signal-fill);
  color: var(--on-signal);
}

.toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--ink-muted);
  font-size: 0.74rem;
  cursor: pointer;
}

.csv {
  margin-left: auto;
  min-height: 28px;
  padding: 0 10px;
  border: 1px solid var(--line-strong);
  background: transparent;
  color: var(--signal);
  cursor: pointer;
  font: inherit;
  font-size: 0.68rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.csv:disabled {
  color: var(--ink-muted);
  cursor: default;
}

.num {
  text-align: right;
  white-space: nowrap;
}

.name {
  color: var(--ink);
  font-weight: 600;
  text-decoration: none;
}

.name:hover {
  color: var(--signal);
  text-decoration: underline;
}

.nameText {
  color: var(--ink);
  font-weight: 600;
}

.date {
  color: var(--ink-muted);
  font-family: var(--mono);
  font-size: 0.72rem;
  white-space: nowrap;
}

@media (max-width: 480px) {
  .csv {
    margin-left: 0;
  }
}
